// ABOUTME: Trainings sidebar icon for coach's training management
// ABOUTME: Shows trending line chart representing workout analytics

import type { FC } from "react"

interface TrainingsSidebarIconProps {
  className?: string
  size?: number
  color?: string
}

export const TrainingsSidebarIcon: FC<TrainingsSidebarIconProps> = ({
  className,
  size = 20,
  color = "currentColor",
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={Math.round((size * 13) / 20)}
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6254 0.8125V6.3125C19.6254 6.49484 19.5529 6.6697 19.424 6.79864C19.2951 6.92757 19.1202 7 18.9379 7C18.7555 7 18.5807 6.92757 18.4517 6.79864C18.3228 6.6697 18.2504 6.49484 18.2504 6.3125V2.47195L11.1743 9.54891C11.1104 9.61283 11.0346 9.66354 10.9512 9.69814C10.8677 9.73273 10.7782 9.75054 10.6879 9.75054C10.5975 9.75054 10.5081 9.73273 10.4246 9.69814C10.3411 9.66354 10.2653 9.61283 10.2015 9.54891L7.25038 6.59695L1.54929 12.2989C1.42029 12.4279 1.24532 12.5004 1.06288 12.5004C0.880445 12.5004 0.705479 12.4279 0.576476 12.2989C0.447473 12.1699 0.375 11.9949 0.375 11.8125C0.375 11.6301 0.447473 11.4551 0.576476 11.3261L6.76398 5.13859C6.82783 5.07467 6.90365 5.02396 6.98711 4.98937C7.07057 4.95477 7.16003 4.93696 7.25038 4.93696C7.34073 4.93696 7.43019 4.95477 7.51365 4.98937C7.59712 5.02396 7.67294 5.07467 7.73679 5.13859L10.6879 8.09055L17.2784 1.5H13.4379C13.2555 1.5 13.0807 1.42757 12.9517 1.29864C12.8228 1.1697 12.7504 0.994836 12.7504 0.8125C12.7504 0.630164 12.8228 0.455295 12.9517 0.326364C13.0807 0.197433 13.2555 0.125 13.4379 0.125H18.9379C19.1202 0.125 19.2951 0.197433 19.424 0.326364C19.5529 0.455295 19.6254 0.630164 19.6254 0.8125Z"
        fill={color}
      />
    </svg>
  )
}
